// eslint-disable-next-line
import React from 'react';
import ReactDOM from 'react-dom';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import injectTapEventPlugin from 'react-tap-event-plugin';
import { grey50, grey100, grey300 } from 'material-ui/styles/colors';
import { browserHistory } from 'react-router';
import Router from './Routes.jsx';
import './css/style.css';
import './css/responsive.css';

injectTapEventPlugin();

const muiTheme = getMuiTheme({
	fontFamily: 'Apercu Mono Regular',
	datePicker: {
		selectColor: '#132F17',
		color: '#132F17',
		selectTextColor: grey50,
	},
	textField: {
		floatingLabelColor: '#132F17',
		hintColor: grey100,
		focusColor: '#132F17',
		color: '#132F17',
		textColor: '#132F17',
		borderColor: '#132F17',
		disabledTextColor: grey300,
	},
	palette: {
		primary1Color: '#132F17',
		accent1Color: '#132F17',
	},
});

ReactDOM.render(
	<MuiThemeProvider muiTheme={muiTheme}>
		<Router history={browserHistory} />
	</MuiThemeProvider>,
	document.getElementById('root'),
);



// WEBPACK FOOTER //
// ./src/index.js